module.exports = __webpack_public_path__ + "media/country_flags/sj-83e5f9bb.png";